import { Navbar } from './types';

const newDeviceTabs = {
  available: [
    { name: 'Overview', value: 'overview' },
    { name: 'Hard disk', value: 'hard_disk' },
    {
      name: 'Management',
      value: 'management',
      subtabs: ['rf_tuning', 'channels', 'speed_test', 'settings']
    },
    {
      name: 'Account',
      value: 'account',
      subtabs: ['provisioned_devices', 'subscriptions', 'dvr', 'vod']
    },
    { name: 'Activity log', value: 'activity_log' },
    {
      name: 'Monitoring',
      value: 'monitoring',
      subtabs: ['device_checks', 'wifi_dashboards'],
    },
  ],
  current: { name: 'Overview', value: 'overview' },
  i18nkey: 'all_device_pages'
};

export function deviceTabs() {
  return newDeviceTabs as Navbar
}

export const navbarWithTabs = [
  '/operational/device/',
];
